export const ADD = 'entities/donationSchedule/ADD';
export const ADD_MULTIPLE = 'entities/donationSchedule/ADD_MULTIPLE';
export const REMOVE = 'entities/donationSchedule/REMOVE';
